import { default as Documents } from "./Documents"
import { default as List } from "./List"
import { default as Activity } from "./Activity"

const Shared = { Documents, List, Activity }
export default Shared
